/* Hype pages — feature video. Click to play, pauses when scrolled away. */

(function () {
  function init() {
    if (!window.HypeCore) return;

    document.querySelectorAll(".hype-video-feature").forEach(function (section) {
      if (section.dataset.hypeVideoFeatureReady === "true") return;
      section.dataset.hypeVideoFeatureReady = "true";

      var video = section.querySelector(".hype-video-noscroll-content");
      if (!video) return;

      window.HypeCore.ready(function (core) {
        core.initVideoPlayer(video, { scope: ".hype-video-noscroll-container" });
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
